
const SupademoEmbed = () => {
  return (
    <div style={{ 
      left: 0, 
      width: '100%', 
      height: 0, 
      position: 'relative', 
      paddingBottom: '57.9102%' 
    }}>
      <iframe 
        src={`https://app.stridecrm.co/v2/preview/AOdvVl8bb0d9CNwYV5aa?notrack=true`}
        style={{ 
          top: 0, 
          left: 0, 
          width: '100%', 
          height: '100%', 
          position: 'absolute', 
          border: 0 
        }}
        allowFullScreen
        allow="clipboard-write *; fullscreen *;"
      />
    </div>
  );
};

export default SupademoEmbed;